import setGlobalState from '../../../redux/setGlobalState';
import store from '../../../store';
import {getEffectiveSessionIntent, getEventTypeIntent, getPayloadIntent} from './agentSchema';
import {sameFieldValues} from './agentObjectUtils';
import type {
    AiAgentPendingProposal,
    AiAgentUiAction,
    AiAgentUiActionPayload,
} from '../../../redux/aiAgent/aiAgent.type';
import type {ChatAskPrompt} from '../../aiMessageGenerator/utils/types';

export function rememberEventTypeFromAsk(value: string | undefined, pendingAsk: ChatAskPrompt | null): void {
    const eventTypeIntent = getEventTypeIntent();
    if(!eventTypeIntent || !value || !pendingAsk?.options?.length) {
        return;
    }
    const locked = getEffectiveSessionIntent();
    if(locked && locked !== eventTypeIntent) {
        return;
    }
    if(pendingAsk.options.some(opt => opt.value === value)) {
        setGlobalState('aiAgent.sessionEventType', value);
    }
}

export function rememberProposalContext(proposal: AiAgentPendingProposal): void {
    if(proposal.eventType) {
        setGlobalState('aiAgent.sessionEventType', proposal.eventType);
    }
    setGlobalState('aiAgent.sessionIntent', proposal.intent);
    setGlobalState('aiAgent.activeFormId', proposal.formId);
}

export function rememberUiActionContext(uiAction: AiAgentUiAction): void {
    const payload = uiAction.payload;
    if(payload?.eventType) {
        setGlobalState('aiAgent.sessionEventType', payload.eventType);
    }
    const intent = getPayloadIntent(payload);
    const locked = getEffectiveSessionIntent();
    if(intent && (!locked || locked === intent)) {
        setGlobalState('aiAgent.sessionIntent', intent);
    }
}

export function rememberCreatedDraft(fields: Record<string, unknown>): void {
    setGlobalState('aiAgent.createdDraftFields', fields);
    // The next turn's change is merged onto these, so a one-field request still carries a
    // complete record.
    setGlobalState('aiAgent.currentFormValues', fields);
}

/** The server marked this turn as another event, not more fields on the current one. */
export function isNewEventRequest(payload: AiAgentUiActionPayload | undefined): boolean {
    return payload?.newEvent === true;
}

/**
 * The producer asked for a change to a record the chat already created. There is no edit
 * action, so the change becomes a new draft built from every value known plus the change —
 * which also means a turn that only repeats the created values must create nothing.
 */
export function isRepeatOfCreatedDraft(proposal: AiAgentPendingProposal): boolean {
    const created = store.getState().aiAgent?.createdDraftFields;
    return !!created && sameFieldValues(created, proposal.fields);
}
